import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { SystemEventLogService } from '../../service/system-event-log.service';

import { AbstractListComponent } from '../../common/abstract-list-component';
import { SystemEventLog } from '../../model/system-event-log';
import { takeUntil } from 'rxjs/operators';
import { Table } from 'primeng/table/table';

@Component({
    selector: 'app-system-event-log-list',
    templateUrl: './system-event-log-list.component.html',
})
export class SystemEventLogListComponent extends AbstractListComponent<SystemEventLog>
    implements OnInit {
    element: SystemEventLog;

    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        protected systemEventLogService: SystemEventLogService
    ) {
        super(router, systemEventLogService, 'system_event_logs');
    }

    ngOnInit() {
        this.loading = true;
        this.element = new SystemEventLog();
    }

    newElement(): SystemEventLog {
        return super.newElement();
    }

    delete(element: SystemEventLog) {
        this.service
            .delete(element.uuid)
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.loaddata(true));
    }

    public reload(datatable: Table) {
        super.reload(datatable);
        this.service.search = {
            ...this.service.search,
            from: {
                ...this.service.search.from,
                received_date: this.service.search.from?.received_date?.split('T')[0],
            },
            to: {
                ...this.service.search.to,
                received_date: this.service.search.to?.received_date?.split('T')[0],
            },
        };
    }

    getId() {
        return this.element.uuid;
    }

    createInstance(): SystemEventLog {
        return new SystemEventLog();
    }

    public preLoaddata() {
        this.appendHourToDate();
    }

    private normalizeDateFilter(dateValue: string, endOfDay = false): string {
        if (!dateValue) {
            return null;
        }

        const dateOnly = dateValue.split('T')[0];
        const separator = dateOnly.includes('/') ? '/' : '-';
        const dateParts = dateOnly.split(separator);

        if (dateParts.length !== 3) {
            return null;
        }

        const normalizedDate =
            dateParts[0].length === 4
                ? `${dateParts[0]}-${dateParts[1]}-${dateParts[2]}`
                : `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;

        return `${normalizedDate}${endOfDay ? 'T23:59:59' : 'T00:00:00'}`;
    }

    public formatDateChip(dateValue: string): string {
        if (!dateValue) {
            return '';
        }

        const dateOnly = dateValue.split('T')[0];
        const dateParts = dateOnly.split('-');

        if (dateParts.length !== 3) {
            return dateOnly;
        }

        return dateParts[0].length === 4
            ? `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`
            : `${dateParts[0]}/${dateParts[1]}/${dateParts[2]}`;
    }

    appendHourToDate() {
        this.service.search = {
            ...this.service.search,
            from: {
                ...this.service.search.from,
                received_date: this.normalizeDateFilter(this.service.search?.from?.received_date),
            },
            to: {
                ...this.service.search.to,
                received_date: this.normalizeDateFilter(
                    this.service.search?.to?.received_date,
                    true
                ),
            },
        };
    }
}
